

import React, { useEffect, useState } from 'react'
import { Button, Container } from 'react-bootstrap'
import AuthNavbar from "../components/AuthNavbar/AuthNavbar"
import HomeTitle from "../components/HomeTitle/HomeTitle"
import { useSelector } from 'react-redux';
import ExportBox from "../components/ExportBox/ExportBox"
import Table from "../components/Table/Table"
import Select from 'react-select';
import axios from 'axios';
import Paginations from './Paginations';
import { useNavigate } from 'react-router-dom';

function Salaries() {
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const userinfo = useSelector((state) => state);
  const navigate=useNavigate()
  const [searchText, setSearchText] = useState("");
  const [total, setTotal] = useState(0)
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationsItems, setPaginationsItems] = useState(null)
  
  // console.log(localStorage.getItem("type") );

  //   const [items, setItems] = useState(localStorage.getItem("type") !== "admin" ? 
  //   [

  //     { id: 0, name: "أحمد", stage: "0100000000", grade: "1000", class: "100", email: "100", type: "Over Time", description: "100", price: "تاخير عن العمل" }


  //   ]: localStorage.getItem("type") != "salaries" ? [{
  //       id: 0, description: "مرتبات شهر 7", date: "17/7/2025", price: "10000", employee: "أحمد", phone: "01021053778"
  //     },
  //     {
  //       id: 1, description: "مرتبات شهر 8", price: "15000", date: "17/8/2025", employee: "أحمد", phone: "01021053778"
  //     },
  //     {
  //       id: 2, description: "مرتبات شهر 9", price: "20000", date: "17/9/2025", employee: "أحمد", phone: "01021053778"
  //     }
  //     ] : [{
  //       id: 0, price: "10000", employee: "أحمد", phone: "01021053778"
  //     },
  //     {
  //       id: 1, price: "15000", employee: "أحمد", phone: "01021053778"
  //     },
  //     {
  //       id: 2, price: "20000", employee: "أحمد", phone: "01021053778"
  //     }
  //     ])
  const type = localStorage.getItem("type");

  let initialItems = [];

  //  else {
  //   initialItems = [
  //     { id: 0, description: "مرتبات شهر 7", date: "17/7/2025", price: "10000", employee: "أحمد", phone: "01021053778" },
  //     { id: 1, description: "مرتبات شهر 8", date: "17/8/2025", price: "15000", employee: "أحمد", phone: "01021053778" },
  //     { id: 2, description: "مرتبات شهر 9", date: "17/9/2025", price: "20000", employee: "أحمد", phone: "01021053778" }
  //   ];
  // }

  const [items, setItems] = useState(initialItems);
  // const type = localStorage.getItem("type");

  let headerIterm = [];

  if (type === "financial") {
    headerIterm = [
      currentLocal.home.ID,
      currentLocal.home.Month,
      currentLocal.home.Academicyear,

      currentLocal.home.Salary,
      currentLocal.home.nameEmployee,
      currentLocal.home.phone,
      currentLocal.home.role,
      currentLocal.home.Bonuses,
      currentLocal.home.Reasonforrewards,
      currentLocal.home.Discounts,
      currentLocal.home.Reasonfordiscount,
      currentLocal.home.priceTotal,
      // currentLocal.home.ID,
      // currentLocal.home.description,
      // currentLocal.home.Salary,
      //     currentLocal.home.Incentives,
      // currentLocal.home.Bonuses,
      // currentLocal.home.Reasonforrewards,
      // currentLocal.home.Discounts,
      // currentLocal.home.Reasonfordiscount,

      // currentLocal.home.date,
      // currentLocal.home.employee,
      // currentLocal.home.phone,
    ];
  } else if (type === "admin") {
    headerIterm = [
      currentLocal.home.ID,
      currentLocal.home.Month,
      currentLocal.home.Academicyear,

      currentLocal.home.Salary,
      currentLocal.home.nameEmployee,
      currentLocal.home.phone,
      currentLocal.home.role,
      currentLocal.home.Bonuses,
      currentLocal.home.Reasonforrewards,
      currentLocal.home.Discounts,
      currentLocal.home.Reasonfordiscount,
      currentLocal.home.priceTotal,
      // currentLocal.home.ID,
      // currentLocal.home.description,
      // currentLocal.home.Salary,
      //     currentLocal.home.Incentives,
      // currentLocal.home.Bonuses,
      // currentLocal.home.Reasonforrewards,
      // currentLocal.home.Discounts,
      // currentLocal.home.Reasonfordiscount,

      // currentLocal.home.date,
      // currentLocal.home.employee,
      // currentLocal.home.phone,
    ];
  } else if (type === "salaries") {
    headerIterm = [
      currentLocal.home.ID,
      currentLocal.home.Month,
      currentLocal.home.Academicyear,

      currentLocal.home.Salary,
      currentLocal.home.nameEmployee,
      currentLocal.home.phone,
      currentLocal.home.role,


      // currentLocal.home.Incentives,
      currentLocal.home.Bonuses,
      currentLocal.home.Reasonforrewards,
      currentLocal.home.Discounts,
      currentLocal.home.Reasonfordiscount,
      currentLocal.home.priceTotal,
            ""

    ];
  }

  // const headerIterm = localStorage.getItem("type") === "sales" ? [
  //   currentLocal.home.ID,
  //   currentLocal.home.employee,
  //   currentLocal.home.phone,

  //   currentLocal.home.Salary,
  //   currentLocal.home.Incentives,

  //   currentLocal.home.Bonuses,
  //   currentLocal.home.Reasonforrewards,
  //   currentLocal.home.Discounts,

  //   currentLocal.home.Reasonfordiscount,
  //   ""
  // ] : localStorage.getItem("type") !== "salaries" ? [
  //   currentLocal.home.ID,
  //   currentLocal.home.description,
  //   currentLocal.home.Salary,
  //   currentLocal.home.date,
  //   currentLocal.home.employee,
  //   currentLocal.home.phone,
  //   ""
  // ] : [
  //   currentLocal.home.Salary,
  //   currentLocal.home.Incentives,

  //   currentLocal.home.Bonuses,
  //   currentLocal.home.Reasonforrewards,
  //   currentLocal.home.Discounts,

  //   currentLocal.home.Reasonfordiscount,
  // ]

  const getData = async () => {
    try {
      const response = await axios.get(
        type === "salaries" ? `https://nanosoft.space/taarteb/public/api/salaries?paginated=10&page=${currentPage}` : `https://nanosoft.space/taarteb/public/api/salaries?paginated=10&page=${currentPage}`,
        {
          headers: {
            Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
          },
        }
      );

      setItems(response.data.data.data);
      const total = response.data.data.data.reduce((sum, item) => sum + (item.final_amount || 0), 0);
        setPaginationsItems(response.data.data.meta);

      if (type === "salaries") {
        const total = response.data.data.data.reduce((sum, item) => sum + (item.total || 0), 0);

        setTotal(total);

      }


    } catch (error) {
      console.log(error);

    }
  }
  const getSalariesAdminData = async () => {
    try {
      const response = await axios.get(
        type === "salaries" ? `https://nanosoft.space/taarteb/public/api/salaries?paginated=10&page=${currentPage}` : `https://nanosoft.space/taarteb/public/api/admin/salaries?paginated=10&page=${currentPage}`,
        {
          headers: {
            Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
          },
        }
      );

        setPaginationsItems(response.data.data.data.meta);

      setItems(response.data.data.data.data);
      setTotal(response.data.data.total_cost);


    } catch (error) {
      console.log(error);

    }
  }
  useEffect(() => {
    if (type === "salaries") {
      getData();
    } else if (type === "admin") {
      getSalariesAdminData()
    } else if (type === "financial") {
      getSalariesAdminData()

    }
  }, [type,currentPage]);

        const filteredItems = items.filter((item) => {
    const search = searchText.toLowerCase();

    const name = item.employee?.name?.toLowerCase() || "";
    const phone = item.employee?.phone?.toLowerCase() || "";
    const date = item.date?.toLowerCase() || "";

    // permissions (roles)
    // const roles = item?.roles
    //   ?.map((r) =>
    //     r?.id == 26 ? item?.job_title : r?.name
    //   )
    //   .join(" ")
    //   .toLowerCase() || "";

    return (
      name.includes(search) ||
      phone.includes(search) ||
      date.includes(search)
    );
  });

    const body = <tbody>
      {filteredItems?.map((item, index) => {
        console.log(filteredItems);
  
        return (
          <tr key={index}>
  
            <td>
              {item?.id}
            </td>
            <td>
              {item?.month}
            </td>
            <td>
              {item?.year}
            </td>
  
            <td>
              {item?.salary}
            </td>
            <td>
              {item?.employee?.name}
            </td>
            <td>
              {item?.employee?.phone}
            </td>
            <td>
              {item?.employee?.role}
            </td>
            <td>
              {item?.bonus?item?.bonus:"____"}
            </td>
            <td>
              {item?.bonus_reason?item?.bonus_reason:"______"}
            </td>
            <td>
                            {item?.deduction?item?.deduction:"______"}

            </td>
            <td>
              {item?.deduction_reason?item?.deduction_reason:"______"}
            </td>
            <td>
              {item?.total}
            </td>
  {localStorage.getItem("type") == "salaries"&&
                                    <td >
                          <div className="form-check" onClick={() => {
                            navigate(`/dashboard/salaries/edite/${item?.id}`)
                          }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                              <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                            </svg>
                          </div>
  
  
                        </td>
      }

  
            {/* {localStorage.getItem("type") !== "purchases" &&
              <td>
                {item.employee?.role ? item.employee?.role : item.employee}
              </td>
            } */}
  
  
            {/* {localStorage.getItem("type") !== "purchases" ?
                    item.status === "rejected" ? (
                      <td
                        className={'pament bg-success'}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          cursor: "pointer"
                        }}
                        onClick={() => {
                          setFeesId(item?.id)
                          setModalShowFees(true)
                        }}
                      >
                        {currentLocal.home.rePay}
                      </td>
                    ):(
                                      <td >
  
                                      <div className='d-flex'>
                                        <Button className='mx-3'
                                          onClick={() => {
                                            setModalShow(true);
                                            setAcceotRejectId(item?.id)
            
                                            setstatusPending('accept')
                                            setIs_registration_fee(item?.is_registration_fee)
            
                                          }}
                                        >{currentLocal.home.accept}</Button>
                                        <Button variant="danger" onClick={() => {
                                          setModalShow(true);
                                          setAcceotRejectId(item?.id)
                                          setstatusPending('reject')
                                        }}>{currentLocal.home.reject}</Button>
                                      </div>
                                      </td>
                    )
                                      
        
  
                                    :
                                    <td >
                          <div className="form-check" onClick={() => {
                            navigate(`/dashboard/purchasess/edite/${item?.id}`)
                          }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                              <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                            </svg>
                          </div>
  
  
                        </td>
      } */}
      
  
            {/* <td>
              {localStorage.getItem("type") !== "purchases" ? (
                item.status === "rejected" ? (
                  <div
                    className="pament bg-success text-center"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setFeesId(item?.id);
                      setModalShowFees(true);
                    }}
                  >
                    {currentLocal.home.rePay}
                  </div>
                ) : (
                  <div className="d-flex">
    
                    {item.status == "pending" &&
                      <Button
                        variant="danger"
                        onClick={() => {
                          setModalShow(true);
                          setAcceotRejectId(item?.id);
                          setstatusPending("reject");
                        }}
                      >
                        {currentLocal.home.reject}
                      </Button>
                    }
                  </div>
                )
              ) : (
                <div
                  className="form-check"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    navigate(`/dashboard/purchasess/edite/${item?.id}`)
                  }
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-pencil-square"
                    viewBox="0 0 16 16"
                  >
                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                    <path
                      fillRule="evenodd"
                      d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                    />
                  </svg>
                </div>
              )}
            </td> */}
  
          </tr>
        )
      })}
  
    </tbody>
  return (
    <div className="px-0 my-3 w-100 dashboard_content">
      <Container>
        <div className="d-flex flex-column w-100">

          <AuthNavbar />
          <div className="mt-5 mx-3">
            <HomeTitle title={currentLocal.home.Salariesprice + " " + "2025"} />
            {localStorage.getItem("type") !== "admin" &&
              <div className='d-flex justify-content-between align-items-center'>
                <div className='d-flex  align-items-center'>
                  {/* <div className='mx-3'>
                    <Select
                      value={grade_id}
                      onChange={(selectedOption) => setGrade_id(selectedOption)}
                      options={options}
                      placeholder={currentLocal.home.Selectyear} // Change this text

                    />
                  </div>
                  <Select
                    value={type_id}
                    onChange={(selectedOption) => setType_id(selectedOption)}
                    options={gradoptions}
                    placeholder={currentLocal.home.SelectMonth} // Change this text

                  /> */}
                </div>
                <ExportBox
                  title={""}
                  paragrapg={' '}
                  addingBtn={currentLocal.home.add + " " + currentLocal.home.Salaries}
                  exportState={false}
                />
              </div>
            }

            <p className="w-100 mb-5 fw-bold"> {currentLocal.home.Salariesprice}:{total} {currentLocal.home.currancy}</p>


      <div className='mb-4 d-flex align-items-center justify-content-between'>
              <div className='d-flex align-items-center'>
                <div className='search'>
                  <input
                    className='px-3 py-1 border- rounded'
                    placeholder={currentLocal.home.search}
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </div>
                <div>
        
                </div>
              </div>
              <Button
                variant="secondary"
                onClick={() => window.print()}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer-fill" viewBox="0 0 16 16">
                  <path d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1" />
                  <path d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
                </svg>
              </Button>
            </div>

            <Table
              data={items}
              headerIterm={headerIterm}
              // onDataChanged={getAllApis}
              // actions={localStorage.getItem("type") !== "salaries" ? localStorage.getItem("type") === "admin" ? ["view"] : ["edit"] : [""]}
              path={`/dashboard/admin/Salary/`}
              body={body}
            />
            {paginationsItems?.last_page > 1 && (

<Paginations
  total={paginationsItems?.last_page}
  currentPage={currentPage}
  onPageChange={(page) => setCurrentPage(page)}
/>
)}
          </div>

        </div>
      </Container>
    </div>)
}

export default Salaries